import { IconButton, TextField, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SearchText: React.FC = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return <TextField type='search' variant='filled' sx={{
        ".MuiFilledInput-root":{
        borderRadius: "8px",
        backgroundColor: theme.palette.primary.main
        },
        ".MuiFilledInput-root::before":{
            border:"0 !important"
        },
        ".MuiFilledInput-root:hover::before":{
            border:0
        },
        ".MuiFilledInput-root::after":{
            border: 0
        },
        "input": {
            padding: "6px 12px !important",
            width: "200px"
        }
    }} InputProps={{ endAdornment: <IconButton size='small' aria-label={t('A11ySearch')}><SearchIcon fontSize='small' /></IconButton>}}
    inputMode='search'
    inputProps={{ "aria-label": t('A11ySearch') }}
     />
}

export default SearchText;